module.exports = __webpack_public_path__ + "static/media/tire-pressure-warning.e4ca4af1.svg";